<!-- 奖项设置 -->
<template>
  <div class="page page-awards bg-red">
    <div class="page__inner">
    <k-block name="ad_banner_1" />
    <k-block name="awards_2_body" />
    </div>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  export default {
    data() {
      return {}
    },
    computed: {
      ...mapState(['myInfo'])
    }
  };

</script>
